<template>
  <div class="settings-mfa">
    <div class="settings-card-top"></div>

    <div class="settings-card-body">
      <h3>Seguridad MFA</h3>
      <p class="settings-subtitle">Protege tu cuenta con verificación en dos pasos para accesos y operaciones sensibles.</p>

      <div class="mfa-status-banner" :class="mfaEnabled ? 'enabled' : 'disabled'">
        <i class="fa" :class="mfaEnabled ? 'fa-shield' : 'fa-shield'"></i>
        <div>
          <h6>{{ mfaEnabled ? 'MFA activado' : 'MFA desactivado' }}</h6>
          <p>
            {{ mfaEnabled
              ? 'Tu cuenta está protegida con autenticación de dos factores.'
              : 'Activa MFA para agregar una capa adicional de seguridad.' }}
          </p>
        </div>
      </div>

      <div class="mfa-main-grid">
        <div class="mfa-config-card">
          <h5>Método de verificación</h5>

          <div class="mfa-method-list">
            <label class="mfa-method-item" :class="{ active: method === 'app' }">
              <input type="radio" name="mfaMethod" value="app" v-model="method" />
              <span>
                <strong>Aplicación autenticadora</strong>
                <small>Google Authenticator, Authy o Microsoft Authenticator.</small>
              </span>
            </label>

            <label class="mfa-method-item" :class="{ active: method === 'email' }">
              <input type="radio" name="mfaMethod" value="email" v-model="method" />
              <span>
                <strong>Código por correo</strong>
                <small>Recibe un código temporal en tu correo registrado.</small>
              </span>
            </label>
          </div>

          <div class="settings-grid mfa-input-grid">
            <div class="settings-field">
              <label>Código de verificación</label>
              <input type="text" class="form-control" v-model="verificationCode" placeholder="Ingresa código de 6 dígitos" />
            </div>

            <div class="settings-field">
              <label>Frecuencia de validación</label>
              <select class="form-control" v-model="validationFrequency">
                <option value="always">En cada inicio de sesión</option>
                <option value="sensitive">Solo en operaciones sensibles</option>
              </select>
            </div>
          </div>

          <div class="settings-actions">
            <button type="button" class="btn btn-light" @click="resetForm">Descartar cambios</button>
            <button type="button" class="btn btn-primary" @click="saveMfa">Guardar configuración</button>
          </div>
        </div>

        <div class="mfa-side-card">
          <h6>Códigos de respaldo</h6>
          <p>Guarda estos códigos en un lugar seguro para recuperar acceso si pierdes tu dispositivo.</p>

          <ul>
            <li v-for="code in backupCodes" :key="code">{{ code }}</li>
          </ul>

          <button type="button" class="btn btn-outline-primary btn-sm" @click="regenerateCodes">
            Regenerar códigos
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsMfaSection',
  data() {
    return {
      mfaEnabled: true,
      method: 'app',
      verificationCode: '',
      validationFrequency: 'always',
      backupCodes: [
        'A7K9-M2P4',
        'Q1R5-T8X2',
        'N3B6-V9L1',
        'D4F7-H2C8',
        'W5Y1-U6J3',
      ],
    };
  },
  methods: {
    resetForm() {
      this.method = 'app';
      this.verificationCode = '';
      this.validationFrequency = 'always';
    },
    saveMfa() {
      this.mfaEnabled = true;
      this.$toast.success('Configuración MFA guardada correctamente.');
    },
    regenerateCodes() {
      this.backupCodes = [
        'Z8L2-P4R6',
        'C5V9-K1M7',
        'S3D4-H8Q2',
        'B1N6-T5Y9',
        'J7U2-W3X4',
      ];
      this.$toast.success('Códigos de respaldo regenerados.');
    },
  },
};
</script>
